/**
 * Flat match list with an O(1) `getMatch(id)` lookup. Mirrors `$utils/getTeams`.
 */

const emptyMatches = () => {
  const matches = [];
  matches.getMatch = () => null;
  return matches;
};

/**
 * @param {Object} matchData - The Opta `matches` payload (i.e. `optaData.matches`).
 * @returns {Array} A flat array of matches with an attached `getMatch` lookup.
 */
export default (matchData) => {
  const matchList = matchData?.matches?.match;
  if (!Array.isArray(matchList) || matchList.length === 0) {
    return emptyMatches();
  }

  const matches = matchList.slice();

  const byId = new Map();
  for (const match of matches) {
    const id = match?.matchInfo?.id;
    if (id) byId.set(id, match);
  }

  matches.getMatch = (id) => (id ? byId.get(id) || null : null);

  return matches;
};
